import { Theme } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import MuiDialogContent from '@mui/material/DialogContent';

export const DialogContent = withStyles((theme: Theme) => ({
  root: {
    color: '#373737',
    padding: `0 ${theme.spacing(4.5)}`,
    '& > ul': {
      paddingLeft: theme.spacing(2),
      '& > li': {
        marginBottom: theme.spacing(2),
      },
    },
    '&:last-child': {
      paddingBottom: theme.spacing(6),
    },
  },
}))(MuiDialogContent);
